<template>
  <el-dialog
    :title="isEdit ? '编辑商家' : '新增商家'"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      class="merchant-form">
      <el-form-item label="商家名称" prop="companyName">
        <el-input v-model="form.companyName" placeholder="请输入商家名称"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson">
        <el-input v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="form.address" type="textarea" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status" v-if="isEdit">
        <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
          <el-option label="正常" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" v-if="!isEdit">
        <el-input v-model="form.password" type="password" placeholder="请输入登录密码"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'MerchantForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    merchantData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        companyName: '',
        contactPerson: '',
        phone: '',
        address: '',
        password: '',
        status: 1
      },
      rules: {
        companyName: [
          { required: true, message: '请输入商家名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.isEdit) {
        this.form = { ...this.merchantData }
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        companyName: '',
        contactPerson: '',
        phone: '',
        address: '',
        password: '',
        status: 1
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleClose() {
      this.resetForm()
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isEdit) {
              await adminApi.updateMerchant(this.form)
              this.$message.success('更新成功')
            } else {
              await adminApi.createMerchant(this.form)
              this.$message.success('创建成功')
            }
            this.handleClose()
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.msg || '操作失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.merchant-form {
  padding: 20px;
}
</style> 